import React from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getPersistedAuthState } from '../shared/authSession';
import { rehydrateSession } from '../store/authSlice';
import GlobalNotificationListener from '../shared/GlobalNotificationListener';

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const persistedAuth = getPersistedAuthState();
  const [isHydrating, setIsHydrating] = React.useState(false);

  React.useEffect(() => {
    if (!isAuthenticated && persistedAuth.isAuthenticated) {
      setIsHydrating(true);
      dispatch(rehydrateSession());
      return;
    }

    setIsHydrating(false);
  }, [dispatch, isAuthenticated, persistedAuth.isAuthenticated]);

  if (isAuthenticated) {
    return <GlobalNotificationListener>{children}</GlobalNotificationListener>;
  }

  if (isHydrating || persistedAuth.isAuthenticated) {
    return null;
  }

  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
